import { arrayContains } from 'Utils';
import Actions from 'Redux/Actions';
import { TRootState } from 'Redux/Reducers';

export const isSalesLoading = (state: TRootState) =>
  arrayContains(state.user.openRequests, [
    Actions.findDailySalesRequest.type,
  ]);



